import { render, staticRenderFns } from "./FacultySpecialitySemesterGroupSelector.vue?vue&type=template&id=0e3ed2b1"
import script from "./FacultySpecialitySemesterGroupSelector.vue?vue&type=script&lang=js"
export * from "./FacultySpecialitySemesterGroupSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports